/**
 * Chọn cột và chép bộ cột giữa các bảng ở hộp "Chọn bảng từ CSDL" — phần thuần của `ChonCot.tsx` và
 * `CopyCotDialog.tsx` native.
 */
import type { IntrospectBang } from '../types.ts';

export type Suggestion = IntrospectBang['suggestion'];

/** Lý do một cột KHÔNG được bỏ: khoá chính, mốc thời gian, cột dùng trong quan hệ. */
export type LyDoKhoa = 'kc' | 'moc' | 'lien';

/**
 * Những cột KHÔNG được bỏ, kèm lý do. Trả cả lý do chứ không chỉ `Set`: một ô bị khoá mà không nói vì sao là một ngõ
 * cụt. Thứ tự có nghĩa — cột vừa là khoá chính vừa là liên kết thì lý do đáng nói là khoá chính (chặn cứng, 422).
 */
export function cotKhoa(s: Suggestion): Map<string, LyDoKhoa> {
  const m = new Map<string, LyDoKhoa>();
  for (const x of s.links ?? []) if (x.column) m.set(x.column, 'lien');
  if (s.updatedAtField) m.set(s.updatedAtField, 'moc');
  for (const k of s.primaryKey ?? []) m.set(k, 'kc');
  return m;
}

/** Bộ cột ĐANG GIỮ ở bảng nguồn, hạ về chữ thường để khớp tên (SAP viết `DocEntry`, trình dò có thể trả `docentry`). */
export function mauCot(nguon: Suggestion, bo: Set<string>): Set<string> {
  const ra = new Set<string>();
  for (const c of nguon.columns ?? []) if (!bo.has(c.name)) ra.add(c.name.toLowerCase());
  return ra;
}

/** Số cột của `dich` có tên trùng với bộ mẫu. Bảng khớp 0 cột thì khoá, không cho tích. */
export function soKhop(mau: Set<string>, dich: Suggestion): number {
  let n = 0;
  for (const c of dich.columns ?? []) if (mau.has(c.name.toLowerCase())) n += 1;
  return n;
}

/**
 * Tập cột phải BỎ ở bảng đích để nó chỉ còn bộ mẫu. Cột khoá KHÔNG bao giờ bị bỏ dù không có trong mẫu: máy chủ từ chối
 * bản khai thiếu chúng (422), và cột mốc mất đi thì bảng lặng lẽ tụt xuống chép đầy mỗi chu kỳ.
 */
export function tinhBoCot(mau: Set<string>, dich: Suggestion): Set<string> {
  const khoa = cotKhoa(dich);
  const bo = new Set<string>();
  for (const c of dich.columns ?? []) {
    if (khoa.has(c.name)) continue;
    if (!mau.has(c.name.toLowerCase())) bo.add(c.name);
  }
  return bo;
}
